<template>
    <AppSeoTags>
        <title>Vehicle Manufacturers</title>

        <link head-key="canonical" rel="canonical" :href="route('manufacturers.index')">
    </AppSeoTags>

    <AppJumbotron>
        <div class="max-w-screen-md">
            <h1 class="text-white mb-8 text-3xl md:text-5xl tracking-wide">
                Find reviews by <span class="font-bold">car manufacturer</span> at {{ config.name }}
            </h1>

            <p class="text-white mb-8">
                To help you choose your next set of tyres, we have pulled together tyre information and customer
                reviews, grouped by car manufacturers. Within each manufacturer's section on our site, you will find the
                most popular tyres fitted by our customers - as well as their thoughts and reviews on the tyres.
            </p>

            <div class="md:max-w-xs">
                <form @submit.prevent="form.get(route('manufacturers.index'), {
                    preserveScroll: true
                })">
                    <AppSearchBar v-model="form.search"
                                  placeholder="Find a car..."></AppSearchBar>
                </form>
            </div>
        </div>
    </AppJumbotron>

    <AppContainer>
        <h3 class="text-dark mt-8 mb-4 text-2xl md:text-3xl">Find tyres for the
            <span class="font-bold">most popular car manufacturers</span></h3>

        <p class="text-dark mb-12">Use the list below to find your car manufacturer</p>

        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"
             v-if="manufacturers.length > 0">
            <ManufacturerCard v-for="manufacturer of manufacturers"
                              :manufacturer="manufacturer"></ManufacturerCard>
        </div>

        <AppAlert v-else type="error" key="form-error">
            We couldn't find any vehicles for your search.
        </AppAlert>
    </AppContainer>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";
import AppJumbotron from "@/Components/AppJumbotron";
import AppSearchBar from "@/Components/AppSearchBar";
import ManufacturerCard from "@/Components/Manufacturers/ManufacturerCard";
import {useForm, Head} from "@inertiajs/inertia-vue3";
import AppAlert from "@/Components/AppAlert";
import AppSeoTags from "@/Components/AppSeoTags";

export default {
    components: {AppSeoTags, AppJumbotron, AppContainer, AppSearchBar, ManufacturerCard, AppAlert, Head},
    props: {
        config: Object,
        manufacturers: Object,
        search: String
    },
    data() {
        return {
            form: useForm({
                search: this.search
            })
        };
    },
    methods: {}
};
</script>

<style scoped>

</style>
